/**
 * Created by Sasha on 7/25/2018.
 */
import moment from 'moment';
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable , BehaviorSubject} from 'rxjs';
import { AppConfig } from '../../app.config';
import {TranslateService} from '@ngx-translate/core';
@Injectable()
export class DynamicDataService  {
  dynamicDatas: any[];
  onDynamicDataChanged: BehaviorSubject<any> = new BehaviorSubject({});
  constructor (private http: HttpClient, private api: AppConfig, private translate: TranslateService) {

  }
  /**
   * Resolve
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
  {

    return new Promise<void>((resolve, reject) => {

      Promise.all([
        this.getDynamicDatas()
      ]).then(
        () => {
          resolve();
        },
        reject
      );
    });
  }

  getDynamicDatas () {
    const lang = this.translate.currentLang;
    return new Promise((resolve, reject) => {
      this.http.get(this.api.baseUrl + '/dynamicData/dynamicDatas?lang=' + lang  , this.api.jsonTokenHeaders)
        .subscribe((response: any) => {
          this.dynamicDatas = response;
          this.onDynamicDataChanged.next(this.dynamicDatas);
          resolve(response);
        }, reject);
    });

  }

  getDynamicDataById(id) {
    return this.http.get(this.api.baseUrl + '/dynamicData/dynamicData?id=' + id , this.api.jsonTokenHeaders);
  }

  deleteDynamicData(id) {
    return this.http.delete(this.api.baseUrl + '/dynamicData/deleteDynamicData?id=' + id , this.api.jsonTokenHeaders);
  }

  addDynamicData(data) {
    return this.http.post(this.api.baseUrl + '/dynamicData/addDynamicData' , data , this.api.formDataHeaders);
  }
}
